export type ValidHttpMethods = 'GET' | 'OPTIONS' | 'POST' | 'PUT';
